import React from 'react';
import {
  Portlet,
  PortletContent,
  PortletHeader,
  PortletLabel,
} from 'components';
import { useIntl } from 'react-intl';
import { List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { Book } from '@mui/icons-material';

export default function Documents() {
  const intl = useIntl();

  const doc = [
    intl.formatMessage({
      id: 'app.groupsCards.hardwareConfig.manuals.concentrator',
    }),
    intl.formatMessage({ id: 'app.groupsCards.hardwareConfig.manuals.card1' }),
    intl.formatMessage({ id: 'app.groupsCards.hardwareConfig.manuals.card2' }),
  ];

  return (
    <Portlet>
      <PortletHeader>
        <PortletLabel
          title={intl.formatMessage({
            id: 'app.groupsCards.hardwareConfig.manuals.title',
          })}
        />
      </PortletHeader>
      <PortletContent>
        <List>
          {doc.map((document, index) => (
            <ListItem key={index}>
              <ListItemIcon>
                <Book />
              </ListItemIcon>
              <ListItemText primary={document} />
            </ListItem>
          ))}
        </List>
      </PortletContent>
    </Portlet>
  );
}
